import { graphql } from 'gatsby';

import indexPageWrapper from '../components/IndexPage';

const indexPage = indexPageWrapper('activities');

export default indexPage;

/* eslint-disable no-undef */
export const pageQuery = graphql`
  query ActivitiesQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(filter: {frontmatter: {path: {regex: "/^\/activities/i" }}}) {
      edges {
        node {
          id
          html
          frontmatter {
            path
            title
            menuOrder
          }
        }
      }
    }
  }
`;
